<template>
  <div class="right">
     <div class="head">
      <div class="had">
        <i :class="$store.state.boo ? 'el-icon-s-unfold':'el-icon-s-fold'" class="icon" @click="$store.commit('change')"  style="margin-left: 1vw;" ></i>
       <el-breadcrumb separator="/" style="margin-left: 10px;">
              <!-- <el-breadcrumb-item>首页</el-breadcrumb-item> -->
              <template v-for="(item,index) in   $route.matched">
               <el-breadcrumb-item :key="item.path"  v-if="!(item.meta.title==='首页' && index===1)">
                  {{ item.meta.title }}
                </el-breadcrumb-item>
              </template>
      </el-breadcrumb>

        <!-- <span id="title" v-for="(item) in  editableTabs" :key="item.name"> {{item.title!=="首页"?'/':''}}{{item.title}}</span> -->

      </div>
        <div>
      <!-- <el-dropdown>
        <i class="el-icon-setting" ></i>
        <el-dropdown-menu slot="dropdown" >
          <el-dropdown-item>查看</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown> -->
      <!-- <span style="margin: 15px">{{user_name}}</span> -->
      <i class="el-icon-switch-button" style="margin: 18px;font-size: 30px;" @click="toLogin"></i>
    </div>
</div>

      <div class="tabs">
    <el-tabs
      v-model="editableTabsValue"
      type="card"

      @tab-remove="removeTab"
      @tab-click="tabClick"
    >
      <el-tab-pane
        v-for="(item) in editableTabs"
        :key="item.name"
        :label="item.title"
        :name="item.name"
        :closable="item.name !== 'Dashboard' && item.name !== 'Statistics'"
      >

      </el-tab-pane>
    </el-tabs>
    <!-- <el-steps :active="1" simple>
  <el-step title="步骤 1" style="width:60px; max-width: 100px;"></el-step>
  <el-step title="步骤 2" icon="el-icon-upload"></el-step>
  <el-step title="步骤 3" icon="el-icon-picture"></el-step>

</el-steps> -->

  </div>

  </div>
</template>

<script>
import Cookies from 'js-cookie'
export default {
  data () {
    return {
      editableTabsValue: 'Dashboard',
      editableTabs: [
        {
          title: '首页',
          name: 'Dashboard'
        }
        // {
        //   title: '数据统计',
        //   name: 'Statistics'
        // }

      ],
      matched: [],
      user_name: ''
      // routerArr: [],
      // isDashboard: true

    }
  },
  watch: {
    $route (to) {
      this.addTab(to)
      // this.getRouterArr()
    }
  },
  mounted () {
    // this.editableTabsValue=this.$route.path
    this.addTab(this.$route)
    this.user_name = localStorage.getItem('user_name')
    console.log(this.$route.matched)
    // this.getRouterArr()

    //   this.$router.push({name: this.editableTabsValue})
  },
  methods: {
    toLogin () {
      Cookies.remove('token')
      localStorage.clear()
      this.$router.push('/login')
    },
    addTab (to) {
      const { name, meta: { title } } = to
      const boo = this.editableTabs.findIndex(item => item.name === name)
      if (boo === -1) {
        this.editableTabs.push({
          title: title,
          name: name

        })
      }
      this.editableTabsValue = name
    },
    tabClick (tab) {
      const { name } = tab
      this.$router.push({
        name: name
      })
    },
    removeTab (targetName) {
      const tabs = this.editableTabs
      let activeName = this.editableTabsValue
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            const nextTab = tabs[index + 1] || tabs[index - 1]
            if (nextTab) {
              activeName = nextTab.name
              this.$router.push({
                name: nextTab.name
              })
            }
          }
        })
      }

      this.editableTabsValue = activeName
      this.editableTabs = tabs.filter((tab) => tab.name !== targetName)
    }
    // getRouterArr () {
    //   // this.isDashboard = this.routerArr.every(item => item.name === '首页')
    //   if (this.$route.matched.every(item => item.meta.title === '首页')) {
    //     this.routerArr = this.$route.matched.splice(0, 1)
    //   } else {
    //     this.routerArr = this.$route.matched
    //   }
    //   console.log(this.$route.matched.every(item => item.meta.title === '首页'))
    // }
  }
}
</script>

<style scoped>

.right {
  height: 100px;
  /* width: 100%;*/
}
.head{
    background-color: #e5f0ff;
    color: #333;
    line-height: 60px;
    margin: 0;
    padding: 0;
    display:flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
  }
  .tabs{
    width: 100%;
  }
.icon{
 vertical-align: middle;
}
.had{
  display:flex;
  line-height: 60px;
}
 .had> #title{
  margin-left: 5px;
  cursor: pointer;
  color:rgb(244, 239, 239);
  display:inline-block;
}
 .had> #title:nth-child(2){
  font-weight:600 ;
  color:rgb(8, 0, 0)
}
.had> #title:nth-child(2):hover{
  color:aqua;
}
div.el-breadcrumb{
  line-height: 60px;
}
.icon{
  line-height: 60px;
}
::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner:nth-child(1){
  color:black;
}
::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner{
  font-weight: 600;
}

</style>
